import _noop from 'lodash/noop';

import ih from 'immutability-helper';

import {
  SELECT_PROJECT,
  ROLLBACK_PROJECT,
} from 'store/services/project/actionTypes';

import { getNextPresentedFileId } from 'store/utils/fileSystem';

export default (reducerName, initialState, reducerHandlers = _noop) => (
  state = initialState,
  action = {},
) => {
  const handlers = {
    [`GET_${reducerName}_FILES_REQUEST`]: () =>
      ih(state, {
        all: {
          isLoading: {
            $set: true,
          },
        },
      }),
    [`GET_${reducerName}_FILES_SUCCESS`]: () =>
      ih(state, {
        all: {
          isLoading: {
            $set: false,
          },
          data: {
            $set: action.payload.files,
          },
          count: {
            $set: action.payload.count,
          },
          currentPage: {
            $set: action.payload.page,
          },
        },
      }),
    [`GET_${reducerName}_FILES_ERROR`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`ADD_${reducerName}_FILE_ERROR`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`UPDATE_${reducerName}_FILE_ERROR`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`DELETE_${reducerName}_FILE_ERROR`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`ADD_${reducerName}_FILE_REQUEST`]: () =>
      ih(state, {
        all: {
          error: {
            $set: '',
          },
          isLoading: {
            $set: false,
          },
        },
      }),
    [`UPDATE_${reducerName}_FILE_REQUEST`]: () =>
      ih(state, {
        all: {
          error: {
            $set: '',
          },
          isLoading: {
            $set: false,
          },
        },
      }),
    [`DELETE_${reducerName}_FILE_REQUEST`]: () =>
      ih(state, {
        all: {
          error: {
            $set: '',
          },
          isLoading: {
            $set: false,
          },
        },
      }),
    [`UPDATE_${reducerName}_FILE_SUCCESS`]: () =>
      ih(state, {
        all: {
          isLoading: {
            $set: false,
          },
          data: {
            $set: action.payload.files,
          },
        },
      }),
    [`ADD_${reducerName}_FILE_SUCCESS`]: () =>
      ih(state, {
        all: {
          data: {
            $apply: data =>
              data.map(file =>
                !file.isNew
                  ? file
                  : {
                      ...action.payload.file,
                    },
              ),
          },
        },
      }),
    [`DELETE_${reducerName}_FILE_SUCCESS`]: () =>
      ih(state, {
        all: {
          data: {
            $apply: data => data.filter(({ id }) => id !== action.payload.id),
          },
          isLoading: {
            $set: false,
          },
        },
        show: {
          presentedId: {
            $apply: curId =>
              getNextPresentedFileId(
                curId,
                [action.payload.id],
                state.all.data,
              ),
          },
        },
      }),
    [`UPLOAD_${reducerName}_FILES_REQUEST`]: () => ({
      ...state,
      upload: {
        isLoading: true,
        error: '',
        files: action.files,
      },
    }),
    [`UPLOAD_${reducerName}_FILE_REQUEST`]: () => ({
      ...state,
      upload: {
        ...state.upload,
        files: action.payload.files.map(f =>
          f.name === action.payload.file.name
            ? {
                name: action.payload.file.name,
                size: action.payload.file.size,
                percentage: action.payload.percentage,
                isLoading: true,
              }
            : f,
        ),
      },
    }),
    [`SET_${reducerName}_DEFAULT_PERCENTAGE_TO_FILE`]: () => ({
      ...state,
      upload: {
        ...state.upload,
        files: action.payload.files,
      },
    }),
    [`UPLOAD_${reducerName}_FILE_SUCCESS`]: () =>
      ih(state, {
        all: {
          data: {
            $unshift: [
              {
                id: action.payload.id,
                name: action.payload.name,
                path: action.payload.path,
                contents: action.payload.contents,
                openedAt: action.payload.openedAt,
              },
            ],
          },
        },
        upload: {
          files: {
            $set: action.payload.uploadingFiles,
          },
        },
      }),
    [`UPLOAD_${reducerName}_FILES_SUCCESS`]: () => ({
      ...state,
      upload: {
        ...state.upload,
        isLoading: false,
        files: [],
      },
    }),
    [`UPLOAD_${reducerName}_FILE_ERROR`]: () => ({
      ...state,
      upload: {
        ...state.upload,
        isLoading: false,
        error: action.payload.error,
        files: action.payload.files,
      },
    }),
    [`UPLOAD_${reducerName}_FILES_ERROR`]: () => ({
      ...state,
      upload: {
        ...state.upload,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [`RESET_${reducerName}_UPLOAD_FILES`]: () => ({
      ...state,
      upload: {
        isLoading: false,
        error: '',
        files: [],
      },
    }),
    [`ADD_${reducerName}_NEW_FILE`]: () =>
      ih(state, {
        all: {
          data: {
            $unshift: [
              {
                ...action.payload.file,
              },
            ],
          },
        },
      }),
    [`UPDATE_${reducerName}_SEARCH_TERM`]: () =>
      ih(state, {
        all: {
          searchTerm: {
            $set: action.payload.searchTerm,
          },
        },
      }),
    [`GET_${reducerName}_FILE_REQUEST`]: () =>
      ih(state, {
        show: {
          isLoading: { $set: true },
          presentedId: { $set: action.payload.id },
        },
      }),
    [`OPEN_${reducerName}_FILE`]: () =>
      ih(state, {
        show: {
          presentedId: { $set: action.payload.id },
        },
      }),
    [`GET_${reducerName}_FILE_SUCCESS`]: () =>
      ih(state, {
        all: {
          data: {
            $apply: data =>
              data.map((file, i) =>
                file.id === action.payload.id
                  ? {
                      ...file,
                      contents: action.payload.data,
                      openedAt: action.payload.isOpened
                        ? state.all.data[i].openedAt
                        : action.payload.openedAt,
                    }
                  : file,
              ),
          },
        },
        show: {
          isLoading: {
            $set: false,
          },
        },
      }),
    [`GET_${reducerName}_FILE_ERROR`]: () => ({
      ...state,
      all: {
        ...state.all,
        error: action.payload.error,
      },
      show: {
        ...state.show,
        isLoading: false,
      },
    }),
    [`CLOSE_${reducerName}_FILE`]: () =>
      ih(state, {
        all: {
          data: {
            $apply: data =>
              data.map(file =>
                file.id !== action.payload.id
                  ? file
                  : {
                      ...file,
                      contents: null,
                      openedAt: 0,
                    },
              ),
          },
        },
        show: {
          presentedId: {
            $apply: curId =>
              getNextPresentedFileId(
                curId,
                [action.payload.id],
                state.all.data,
              ),
          },
        },
      }),
    [`UPDATE_${reducerName}_BLOB_REQUEST`]: () =>
      ih(state, {
        show: {
          isSaving: { $set: true },
        },
      }),
    [`UPDATE_${reducerName}_BLOB_SUCCESS`]: () => ({
      ...state,
      all: {
        ...state.all,
        data: action.payload.files.map(f =>
          f.path === action.payload.file.path
            ? {
                ...f,
                lastUpdateTimestamp: Date.now(),
                contents: action.payload.contents,
              }
            : f,
        ),
      },
      show: {
        ...state.show,
        isSaving: false,
      },
    }),
    [`UPDATE_${reducerName}_BLOB_ERROR`]: () => ({
      ...state,
      show: {
        ...state.show,
        isSaving: false,
        error: action.payload.error,
      },
    }),
    [`UPDATE_${reducerName}_EDITOR_SEARCH_TERM`]: () =>
      ih(state, {
        show: {
          searchTerm: {
            $set: action.payload.searchTerm,
          },
        },
      }),
    [`SET_${reducerName}_THEME`]: () =>
      ih(state, {
        show: {
          theme: {
            $set: action.payload.theme,
          },
        },
      }),
    [`SET_${reducerName}_THEME`]: () =>
      ih(state, {
        show: {
          theme: {
            $set: action.payload.theme,
          },
        },
      }),
    [`DELETE_${reducerName}_FILES_REQUEST`]: () =>
      ih(state, {
        all: {
          error: {
            $set: '',
          },
          isLoading: {
            $set: false,
          },
        },
      }),
    [`DELETE_${reducerName}_FILES_SUCCESS`]: () =>
      ih(state, {
        all: {
          data: {
            $apply: data =>
              data.filter(({ id }) => !action.payload.deletedIds.includes(id)),
          },
        },
        show: {
          presentedId: {
            $apply: curId =>
              getNextPresentedFileId(
                curId,
                action.payload.deletedIds,
                state.all.data,
              ),
          },
        },
      }),
    [`DELETE_${reducerName}_FILES_ERROR`]: () => ({
      ...state,
      all: {
        ...state.all,
        isLoading: false,
        error: action.payload.error,
      },
    }),
    [SELECT_PROJECT]: () => ({
      ...state,
      ...initialState,
    }),
    [ROLLBACK_PROJECT]: () => ({
      ...state,
      ...initialState,
    }),
    ...reducerHandlers(state, action),
  };

  const matchingHandler = handlers[action.type];

  if (matchingHandler) {
    return matchingHandler(state, action);
  }

  return state;
};
